import { setHtmlLang } from './helpers';

export const initOneTrust = () => {
    const domainId = import.meta.env.ONE_TRUST_ID;

    if (domainId) {
        const { head } = document;
        const script = document.createElement('script');

        script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
        script.type = 'text/javascript';
        script.setAttribute('data-document-language', 'true');
        script.setAttribute('data-domain-script', domainId);
        script.setAttribute('data-attempt', domainId);

        head.insertBefore(script, head.firstChild);

        setHtmlLang();
    } else {
        console.error('OneTrust Error: No ID for this domain');
    }
};
